module.exports = __webpack_public_path__ + "static/media/wenzhoushi_projects.1b9363d4.docx";